import {
  ChangeDetectorRef, Component, ViewChild, Inject,
  Input, Renderer2,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';

import { DefaultModalComponent } from 'shared/modal/default-modal/default-modal.component';
import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { BrandService } from 'shared/brand/brand.service';
import { ImportManagerService } from 'shared/import-manager/import-manager.service';


@Component({
  moduleId: module.id,
  selector: 'report-modal',
  templateUrl: 'report-modal.component.html',
  styleUrls: ['report-modal.component.scss'],
})
export class ReportModalComponent extends BaseModalComponent {

  @Input() importItem: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    protected router: Router,
    private _renderer: Renderer2,
    private ref: ChangeDetectorRef,
    public brandService: BrandService,
    public importManagerService: ImportManagerService
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

   get filename(): string {
     return this.importItem ? this.importItem.filename : '';
   }

   get filetype(): string {
     return this.importItem ? this.importItem.type : '';
   }

   get isTotalFail(): boolean {
     return this.importItem ? this.importItem.report.status === 3 : false;
   }

   get isTotalSuccess(): boolean {
     return this.importItem ? this.importItem.report.status === 1 : false;
   }

   get countSuccess(): number {
     return this.importItem ? this.importItem.report.success_count : 0;
   }

   get countFail(): number {
     return this.importItem ? this.importItem.report.fail_count : 0;
   }

   get countFileError(): number {
     return this.importItem ? this.importItem.report.file_error_count : 0;
   }

   get itemsTitle(): string {
     if (this.importItem) {
       if (this.importItem.import_type.indexOf('ITEMS') >= 0) { return 'Products'; }
       if (this.importItem.import_type.indexOf('APPS') >= 0) { return 'Fitments'; }
     }
     return 'Items';
   }

   get linesText(): string {
     if (this.importItem && this.importItem.report) {
       return this.importItem.report.errors.join('. ');
     }
     return '';
   }

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onImportCatalogClick() {
    if (this.importItem.import_type.indexOf('ITEMS') >= 0) {
      this.router.navigate([`/import-manager/import-review-pies/${this.importItem.parts_import_id}`], { queryParams: {csm: 1}});
    } else if (this.importItem.import_type.indexOf('APPS') >= 0) {
      this.router.navigate([`/import-manager/import-review-aces/${this.importItem.parts_import_id}`], { queryParams: {csm: 1}});
    } else if (this.importItem.import_type.indexOf('CUSTOM FIELDS') >= 0) {
      this.router.navigate([`/import-manager/import-review-custom-fields/${this.importItem.parts_import_id}`], { queryParams: {csm: 1}});
    }
  }

  onDownloadErrorReportClick() {
    console.log('importItem', this.importItem);
    // TODO: add download by real src parameter
    this.importManagerService.downloadErrorReport(this.brandService.getBrand(), this.importItem.parts_import_id)
      .subscribe((res) => {
        console.log(res);
        const filename = `error-report-${this.importItem.parts_import_id}.csv`;
        FileSaver.saveAs(res, filename);
      }); 
  }
}
